var createHistory = require("history").createBrowserHistory
export const history = createHistory()